import React, { FC, memo } from 'react'
import { NonFlexingContainer, SplashScreen } from '@sport1/news-styleguide'

type Props = {
    text: string
}

const FullSplashScreen: FC<Props> = ({ text }) => {
    return (
        <NonFlexingContainer minHeight={600}>
            <SplashScreen caption={text} />
        </NonFlexingContainer>
    )
}

export default memo(FullSplashScreen)
